//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    arrs: {
      type: Array,
      default: () => [],
    },
    buttonName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      show: false,
      dynamicValidateForm: {
        arr: [],
      },

      prefix: 'https://',
    };
  },
  mounted() {
    this.dynamicValidateForm.arr = [...this.arrs];
  },
  methods: {
    handleDomainSure(val) {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const del = new Set(this.arrs);
          const add = new Set();
          val.forEach((e) => {
            if (!del.has(e)) {
              add.add(e);
            }
            del.delete(e);
          });
          this.$emit('handleDomainSure', Array.from(add));
          this.$emit('handleDel', Array.from(del));
        } else {
          return false;
        }
      });
      // const newArr = val.map((item) => {
      //   return this.prefix + item;
      // });
    },
    handleDelDomain(index) {
      this.dynamicValidateForm.arr.splice(index, 1);
    },
    handleAddDomain() {
      //   this.$emit('handleAddDomain');
      this.dynamicValidateForm.arr.push('');
    },
    handleCancel() {
      this.$emit('handleCancel');
    },
  },
};
